<template>
  <section v-if="cancellationPolicy" id="cancellation-policy">
    <SectionHeading icon="icon-insurance-umbrella-heart" title="Cancellation policy" />

    <div class="policy-html" v-html="cancellationPolicy.html"></div>
  </section>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'

const {
  data: { cancellationPolicy },
} = useItineraryStore()
</script>

<style lang="scss" scoped>
section {
  @include flex-column(20px);
}

.policy-html:deep(p) {
  font-weight: 400;
  margin-block: 0;
}
</style>
